export class Term {
  id: string;
  name: string;
  body: string;
}



// WEBPACK FOOTER //
// ./src/classes/term.ts